import { useQuery } from '@tanstack/react-query';
import { QueryKey } from '../../queryKeys';
import { useNftx } from '@nftx/react';
import { CreateInventoryPositionQuoteParams } from 'nftx.js';

const useCreateInventoryPositionQuote = ({
  userAddress,
  vaultId,
  tokenIds,
  vToken,
}: CreateInventoryPositionQuoteParams) => {
  const {
    network,
    core: { quoteCreateInventoryPosition },
  } = useNftx();

  return useQuery(
    [
      QueryKey.CREATE_INVENTORY_POSITION_QUOTE,
      network,
      vaultId,
      tokenIds,
      userAddress,
      vToken,
    ],
    () => {
      return quoteCreateInventoryPosition({
        network,
        tokenIds,
        userAddress,
        vaultId,
        vToken,
        usePermit2: true,
      });
    }
  );
};

export default useCreateInventoryPositionQuote;
